module.exports = __webpack_public_path__ + "img/CardImageSurvey12.ae5e795f.png";